// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_3csaFH7tbcRXdSU5l7", // asep
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/7sIcNF3FcffUebe9Bm", // asep

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Audio Separator AI 🔊",
    HOME_PAGE_TITLE: "Home - Audio Separator AI 🔊",
    DASHBOARD_PAGE_TITLE: "Home - Audio Separator AI 🔊",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Audio Separator AI 🔊",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to separate out sounds in a file, choose an audio file and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "audio_separator_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/audio-separator-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;